var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Care"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.24 16.7509C11.1236 16.7509 11.0097 16.7854 10.9129 16.8501C10.8161 16.9148 10.7406 17.0067 10.6961 17.1143C10.6515 17.2219 10.6398 17.3403 10.6626 17.4545C10.6853 17.5687 10.7413 17.6736 10.8237 17.756C10.906 17.8383 11.0109 17.8944 11.1251 17.9171C11.2394 17.9398 11.3577 17.9281 11.4653 17.8836C11.5729 17.839 11.6648 17.7636 11.7295 17.6667C11.7942 17.5699 11.8288 17.4561 11.8288 17.3396C11.8288 17.1835 11.7667 17.0337 11.6563 16.9233C11.5459 16.8129 11.3962 16.7509 11.24 16.7509Z",
    fill: "#171926",
    stroke: "#171926",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.2401 14.058V7.39129",
    stroke: "#171926",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.6811 2.29756C12.5488 2.02824 12.3437 1.80138 12.089 1.64273C11.8343 1.48408 11.5403 1.39999 11.2402 1.39999C10.9402 1.39999 10.6461 1.48408 10.3914 1.64273C10.1367 1.80138 9.93161 2.02824 9.79932 2.29756L1.37879 19.4515C1.27743 19.6577 1.23029 19.8863 1.24182 20.1158C1.25334 20.3453 1.32316 20.568 1.44468 20.763C1.5662 20.958 1.73541 21.1188 1.93633 21.2303C2.13725 21.3417 2.36326 21.4001 2.59302 21.4H19.8874C20.1172 21.4001 20.3432 21.3417 20.5441 21.2303C20.745 21.1188 20.9143 20.958 21.0358 20.763C21.1573 20.568 21.2271 20.3453 21.2386 20.1158C21.2502 19.8863 21.203 19.6577 21.1017 19.4515L12.6811 2.29756Z",
    stroke: "#171926",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgWarning;